import React, { useState, useEffect, memo } from 'react';
import {
    USBModal,
    USBModalFooter,
    USBModalBody,
    USBModalHeader,
    USBModalCloseIcon,
} from '@usb-shield/react-modal';
import { USBSubmitButton } from '@usb-shield/forms-beta';
import './EmailModal.scoped.scss';
import { useDispatch, useSelector } from 'react-redux';
import USBLoader from '@usb-shield/components-react/dist/cjs/loader';
import { sendEmailWithRecommendations } from '../../../redux/actions';
import defaultLang from '../../../language';

const backdrop1 = true;
const describedBy = 'modal-description';
const labelledBy = 'modal-title';

function EmailStatusModal({
    isOpen,
    closeModal,
    dataflag,
    emailPayload,
    onReportingDataResultsHandler,
}) {
    const dispatch = useDispatch();
    const [modalTextObject, setModalTextObject] = useState({
        headerText: '',
        bodyText: '',
    });
    const isEmailSentProcessing = useSelector(
        (state) => state.sendEmailRecommendationsReducer.isLoading,
    );

    const sendEmailStatusSuccess = useSelector(
        (state) =>
            state.sendEmailRecommendationsReducer.isEmailSentSuccess,
    );
    const sendEmailStatusFailure = useSelector(
        (state) =>
            state.sendEmailRecommendationsReducer.isEmailSentFailed,
    );

    useEffect(() => {
        if (isOpen) {
            dispatch(sendEmailWithRecommendations(emailPayload));
        }
    }, [isOpen]);

    useEffect(() => {
        if (isEmailSentProcessing) {
            setModalTextObject({
                headerText: `${defaultLang.recommendation.emailStatusModal.emailProcessingHeader}`,
                bodyText: `${defaultLang.recommendation.emailStatusModal.emailProcessingBody}`,
            });
        }
        if (sendEmailStatusSuccess) {
            setModalTextObject({
                headerText:
                    `${defaultLang.recommendation.emailStatusModal.emailSentHeader}` +
                    `${emailPayload.toEmail}.`,
                bodyText: `${defaultLang.recommendation.emailStatusModal.emailSentBody}`,
            });
        }
        if (sendEmailStatusFailure) {
            onReportingDataResultsHandler(
                defaultLang.recommendation.emailStatusModal
                    .emailErrorHeader,
            );
            setModalTextObject({
                headerText: `${defaultLang.recommendation.emailStatusModal.emailErrorHeader}`,
                bodyText: `${defaultLang.recommendation.emailStatusModal.emailErrorBody}`,
            });
        }
    }, [
        isEmailSentProcessing,
        sendEmailStatusSuccess,
        sendEmailStatusFailure,
    ]);

    return (
        <USBModal
            isOpen={isOpen}
            backdrop={backdrop1}
            className={`tnc-modal ${
                dataflag ? 'main--container' : ''
            }`}
            describedBy={describedBy}
        >
            <USBModalCloseIcon
                handleModalClose={() => closeModal(false)}
                aria-label="close"
            />
            <div className="modal-header-section">
                <USBModalHeader
                    id="tnc-modal-header"
                    className="tnc-header"
                    labelledBy={labelledBy}
                    tag="h2"
                    modalTitle={modalTextObject.headerText}
                />
            </div>

            <USBModalBody>
                {modalTextObject.bodyText}
                {isEmailSentProcessing && (
                    <span>
                        <USBLoader />
                    </span>
                )}
            </USBModalBody>
            {(sendEmailStatusSuccess || sendEmailStatusFailure) && (
                <USBModalFooter>
                    <div
                        className={`${
                            !dataflag ? 'add-margin-right' : ''
                        } modalclose`}
                        data-flag={dataflag ? 'true' : 'false'}
                    >
                        <USBSubmitButton
                            variant="primary"
                            onSubmit={() => closeModal(false)}
                        >
                            {
                                defaultLang.recommendation
                                    .emailStatusModal
                                    .emailModalCloseButton
                            }
                        </USBSubmitButton>
                    </div>
                </USBModalFooter>
            )}
        </USBModal>
    );
}
EmailStatusModal.displayName = 'EmailStatusModal';

export default memo(EmailStatusModal);
